"use client"

import React from "react"
import { GoogleAnalytics } from "nextjs-google-analytics"

export default function GoogleAnalyticsProvider() {
  return (
    <GoogleAnalytics
      trackPageViews
      gaMeasurementId={process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID}
      strategy="lazyOnload"
    />
  )
}
